import { connectToStores } from 'fluxible-addons-react';
import { RouteStore } from 'fluxible-router';
import { QUANTUM_UI } from '../../../../flags';
import NavigationStore from '../../../stores/NavigationStore';
import { GlossaryPage } from './GlossaryPage';
import { GlossaryPage as GlossaryPageOld } from './GlossaryPage.old';
var GlossaryPageComponent = QUANTUM_UI ? GlossaryPage : GlossaryPageOld;
export default connectToStores(GlossaryPageComponent, [RouteStore, NavigationStore], function (_a) {
    var _b;
    var getStore = _a.getStore;
    var route = getStore(RouteStore).getCurrentRoute();
    var glossary = getStore(NavigationStore).getGlossary();
    return {
        termLetters: glossary.termLetters,
        termsByLetter: glossary.termsByLetter,
        terms: glossary.terms,
        query: (_b = route === null || route === void 0 ? void 0 : route.query) === null || _b === void 0 ? void 0 : _b.term,
    };
});
